import React from 'react';
import DOMPurify from 'dompurify';

const NoticiaTexto = ({ descricao }) => {
    const sanitizedDescricao = DOMPurify.sanitize(descricao);
    return(
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-6 mb-sm-20" >
                    <div dangerouslySetInnerHTML={{ __html: sanitizedDescricao }} />
                </div>
            </div>
        </div>
    );
}

export default NoticiaTexto;